import { DefaultFormConfig, setFormConfig } from 'sos-eservice-common/js/config';
import { ResourceItem, StepFieldsMap } from 'sos-common/js/commonTypes';
import { allFormActions } from 'sos-eservice-common/js/Redux/Actions/allActionTypes';
import { ADD_FILE } from 'sos-eservice-common/js/Redux/Actions';
export class ResearchConfig extends DefaultFormConfig {
  constructor(translations: ResourceItem[], public basePath: string, public stepFieldsMap: StepFieldsMap) {
    super(translations, basePath, stepFieldsMap);
  }

  public errorMessageResolver(action: allFormActions) {
    if (
      action.type === ADD_FILE &&
      (action.fieldName === 'variabellista' ||
        action.fieldName === 'kodlistaLakemedelsRegistret' ||
        action.fieldName === 'kodlistaPatientRegistret' ||
        action.fieldName === 'kodlistaDodsorsaksRegistret')
    ) {
      return this.translate('/global/variabellistaFileUploadError');
    }
    return super.errorMessageResolver(action);
  }
}
